import * as Sentry from '@sentry/nextjs';
import { Integrations as TracingIntegrations } from '@sentry/tracing';

Sentry.init({
  dsn: 'https://cd79a2afce454dbf9cbb09e4773fcf95@o828979.ingest.sentry.io/5882372',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,
  environment: process.env.APP_ENV === 'production' ? 'production' : 'staging',
  integrations: [new TracingIntegrations.BrowserTracing()],
  ignoreErrors: [
    /Abstract type "SearchParamReturnType" must resolve/,
    /Relay fetch error: You should be logged in for this/,
    /NetworkError when attempting to fetch resource/,
    /Failed to fetch/,
    /401: UNAUTHORIZED/,
    /^Relay fetch error: Token not found$/,
    /^Illegal invocation$/,
  ],
  //
  // Only report errors from whole URLs matching a regex pattern or an exact string.
  // whitelistUrls should match the URL of our actual JavaScript files.
  // It should match the URL of your site if and only if you are inlining code inside &lt;script&gt; tags.
  //
  allowUrls: [
    /^https:\/\/static\.kiwi.com\/modules\/account/gi, // This is for production
    /fe-cloudrun.kiwi.com/gi, // This is for staging
  ],
});
